import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import RecordingApp from './recording/RecordingApp';
import SynthTestApp from './synthtest/SynthTestApp';
import LiveDemoApp from './livedemo/LiveDemoApp';
import OnlineExamApp from './onlineexam/OnlineExamApp';
import {
  IS_RECORDING_MODE, IS_SYNTHTEST_MODE, IS_LIVEDEMO_MODE, IS_ONLINEEXAM_MODE,
} from './config/constants';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {IS_ONLINEEXAM_MODE ? <OnlineExamApp />
      : IS_LIVEDEMO_MODE ? <LiveDemoApp />
      : IS_SYNTHTEST_MODE ? <SynthTestApp />
      : IS_RECORDING_MODE ? <RecordingApp />
      : <App />}
  </React.StrictMode>
);
